"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getJobSubTypes = void 0;
const axios_1 = __importDefault(require("axios"));
async function getJobSubTypes() {
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: '/https-job/api/job/jobsubtypes'
    });
    return resp.data;
}
exports.getJobSubTypes = getJobSubTypes;
